import { memo } from 'react';
import Box from '@mui/material/Box';
import { CircularProgress } from '@mui/material';

function FuseSplashScreen() {
  return (
    <div id="fuse-splash-screen">
      <div className="logo">
        <Box sx={{ display: 'flex' }}>
          <CircularProgress />
        </Box>
      </div>
    </div>
  );
}

export default memo(FuseSplashScreen);
